import type { Editor } from '@tiptap/react'

/**
 * The editor's CURRENT JSON value-string, read straight from the live
 * instance rather than from the parent's `body` state.
 *
 * `<MarkdownEditor>` debounces `onChange` by 300ms, so a submit fired
 * within that window of the last edit would otherwise post the PREVIOUS
 * body — dropping just-typed text, or re-sending an embed the author has
 * just deleted. Submit paths read here; `fallback` (the debounced state)
 * covers an editor that is not mounted or has been torn down.
 */
export function readLiveEditorJson(
  editor: Pick<Editor, 'getJSON' | 'isDestroyed'> | null | undefined,
  fallback: string,
): string {
  if (!editor || editor.isDestroyed) return fallback
  try {
    return JSON.stringify(editor.getJSON())
  } catch {
    return fallback
  }
}
